<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('renewes')"
          :directory="[$t('renewes'), $t('renewe')]"
          :icon="'users'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="text-sm-right mb-primary mb-sm-0 mb-md-0">
          
        
        </div>
      </div>
    </div>
    <app-table :id="tableId" :options="options" @action="getAction" />

    <app-renewe-modal
      v-if="isReneweModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      @close-modal="closeModal"
    />
  
    <app-confirmation-modal
      v-if="confirmationModalActive"
      modal-id="renewe-delete-modal"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />

    

  
 
   
   
  </div>
</template>
<script>
import CoreLibrary from "@core/helpers/CoreLibrary.js";
import { collection, urlGenerator, formatDateToLocal ,numberWithCurrencyMuseum } from "@app/Helpers/helpers";
import { mapGetters } from "vuex";
import { owner } from "@app/Mixins/Global/FilterMixins";
import { DeleteMixin } from "@app/Mixins/Global/DeleteMixin";
export default {
  name: "Renewe",
  extends: CoreLibrary,
  mixins: [owner, DeleteMixin],
  data() {
    return {
      urlGenerator,
      numberWithCurrencyMuseum,
      isReneweModalActive: false,
      isContactModalActive: false,
      tableId: "renewe-modal",
      contacttableId: "contact-modal",
      confirmationModalActive: false,
      isQuickViewModalActive: false,
      organizationModal: false,
      reneweActivitiesModal: false,
      editedUrl: "",
      viewAllDeal: false,
      viewAllFollower: false,
      isNoteModal: false,
      noteRowData: null,
      reneweId: null,
      selectedUrl: "",
      activityData: {},
      followerUrl: "",
      
      options: {
        name: this.$t("renewe_table"),
        url: "crm/renewes",
        showHeader: true,
        countView: true,
        columns:  [
        
	    {
          title: this.$t("fund"),
          type: "custom-html",
          key: "fund",
          modifier: (value, row) => {
			  return '<a href="/crm/funds/'+value.id+'/edit">'+value.name+'</a>';
          },
        },
	    {
          title: this.$t("status"),
          type: "custom-html",
          key: "status",
          modifier: (value, row) => {
            let status = (value == 1) ? this.$t('status_renewe_process') : this.$t('status_renewe_done');
            let color = (value == 1) ? 'badge-danger' : 'badge-success';
            return '<span class="badge badge '+color+' badge-pill mr-2">'+status+'</span>';
          },
        },
        {
          title: this.$t("price"),
          type: "custom-html",
          key: "price",
          modifier: (value, row) => {
			  return numberWithCurrencyMuseum(value);
          },
        },
        {
          title: this.$t("person_res"),
          type: "custom-html",
          key: "person",
          modifier: (value, row) => {
            return '<a href="/crm/persons/'+value.id+'/edit">'+value.name+'</a>';
		
          },
        },
        {
          title: this.$t("date_on"),
          type: "custom-html",
          key: "date_on",
          modifier: (value, row) => {
            return value
              ? `<span>${formatDateToLocal(value)}</span>`
              : "-";
          },
        },
        {
          title: this.$t("date_off"),
          type: "custom-html",
          key: "date_off",
          modifier: (value, row) => {
            return value
              ? `<span>${formatDateToLocal(value)}</span>`
              : "-";
          },
        },
        {
          title: this.$t("owner"),
          type: "custom-html",
          key: "owner",
          modifier: (value, row) => {
            return value
              ? value.full_name
              : `<p class="font-size-80 text-secondary">` +
                  this.$t("deal_has_no_owner") +
                  `</p>`;
          },
        },
	    
				
		
        {
          title: this.$t("action"),
          type: "action",
          key: "invoice",
          isVisible: true,
        },
      ],
        filters: [
       
        
          {
            title: this.$t("status"),
            type: "radio",
            key: "with_manne",
            option: [
            {
                id: 2,
                name: this.$t('status_renewe_done'),
              },
            {
                id: 1,
                name: this.$t('status_renewe_process'),
              },
            ],
            listValueField: "name",
          },
		
         
        ],
        showSearch: true,
        showFilter: true,
        paginationType: "pagination",
        responsive: false,
        rowLimit: 50,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
        actions: [
          /*{
            title: this.$t("quick_view"),
            icon: "zap",
            type: "modal",
            component: "app-renewe-quick-view",
            modalId: "quickViewModal",
            url: "",
          },*/
          {
            title: this.$t("edit_more"),
            icon: "external-link",
            type: "page-redirect",
            modalId: "renewe-modal",
            url: "",
          },
          {
            title: this.$t("delete"),
            icon: "trash",
            type: "modal",
            component: "app-confirmation-modal",
            modalId: "renewe-delete-modal",
            url: "",
          },
        ],
      },
    };
  },
  methods: {
	  
	getReneweValue() {
      this.axiosGet("crm/renewe-value").then((response) => {
        this.options.filters.push({
          title: this.$t("renewe_value"),
          type: "range-filter",
          key: "renewe-value",
          minTitle: this.$t("minimum_value"),
          maxTitle: this.$t("maximum_value"),
          maxRange: response.data.max_renewe_value,
          minRange:
            response.data.min_renewe_value < response.data.max_renewe_value
              ? response.data.min_renewe_value
              : 0,
        });
      });
    },
    getAction(rowData, actionObj, active) {
      if (actionObj.title == this.$t("edit_more")) {
        //this.selectedUrl = `crm/renewes/${rowData.id}`;
        //this.isReneweModalActive = true;
        window.location = `/crm/renewes/${rowData.id}/edit`;
      } else if (actionObj.title == this.$t("delete")) {
        this.deleteUrl = `crm/renewes/${rowData.id}`;
        this.confirmationModalActive = true;
      } 
    },
    openModal() {
      this.isReneweModalActive = true;
    },


    closeModal() {
      this.isReneweModalActive = false;
      this.selectedUrl = "";
      $("#renewe-modal").modal("hide");
    },
 
 
   
 
   

  },
  computed: {

  },
  mounted() {
   
	  setTimeout(() => {
      // this.$store.dispatch("getOwner"),
      this.getReneweValue();
    }, 1000);
  },
};
</script>
<style>
.link-list {
  white-space: nowrap !important;
  max-width: 180px;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
